<ng-container *ngIf="this.selectedTab === 0">
  <form [formGroup]="balanceSheetBeforeAfterAppropriationResultsFg">
    <div>
      <snelstart-ui-select-form-control formControlName="value"
                                        class="me-1 custom-input-250"
                                        label="Balans voor of na resultaatbestemming"
                                        [options]="this.optionsVoorNaResultaatbestemming"
                                        (change)="this.onValueChange()">
      </snelstart-ui-select-form-control>
    </div>
  </form>
  <div class="row">
    <div class="col col-1">
    </div>
    <div class="col-2 bold">
      Huidige periode
    </div>
    <div class="col-3 bold">
      Vorige periode
    </div>
  </div>
  <div class="pt-3"></div>
  <ng-container *ngIf="this.showCustomControls">
    <form [formGroup]="shareCapitalPaidCalledUpFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">
        <div class="col col-1">
          <p style="padding: 6px">Gestort en opgevraagd {{ isCooperatie ? "ledenkapitaal" : "aandelenkapitaal"}}</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(0)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="sharePremiumFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">

        <div class="col col-1">
          <p style="padding: 6px">Agio</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(1)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="revaluationReserveFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">

        <div class="col col-1">
          <p style="padding: 6px">Herwaarderingsreserve</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(2)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="legalReservesFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">

        <div class="col col-1">
          <p style="padding: 6px">Andere wettelijke reserves</p>
        </div>
        <div class="col-2"></div>
        <ng-container>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </ng-container>
      </div>
    </form>
    <form [formGroup]="statutoryReservesFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">

        <div class="col col-1">
          <p style="padding: 6px">Statutaire reserves</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(3)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="reservesOtherFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig">

        <div class="col col-1">
          <p style="padding: 6px">Overige reserves</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(4)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="reinvestmentReserveFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && isFiscaleGrondslagen">

        <div class="col col-1">
          <p style="padding: 6px">Herinvesteringsreserve</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(42)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="otherFiscalReservesFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && isFiscaleGrondslagen">

        <div class="col col-1">
          <p style="padding: 6px">Overige fiscale reserves</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(41)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="resultForTheYearFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && !isBalansNaResultaatbestemming">

        <div class="col col-1">
          <p style="padding: 6px">Resultaat na belastingen van het boekjaar</p>
        </div>
        <div class="col-2">
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="retainedEarningsFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig">

        <div class="col col-1">
          <p style="padding: 6px">Niet verdeelde winsten</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(6)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="equityFg">
      <div class="row" *ngIf="isEnkelvoudig">

        <div class="col col-1">
          <p style="padding: 6px"><b>Totaal van eigen vermogen</b></p>
        </div>
        <div class="col-2"></div>
        <ng-container>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </ng-container>
      </div>
    </form>
    <form [formGroup]="noncontrollingInterestFg">
      <div class="row" *ngIf="isRechtspersoon && !isEnkelvoudig">
        <div class="col col-1">
          <p style="padding: 6px">Aandeel van derden in groepsmaatschappijen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(8)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="equityGroupFg">
      <div class="row" *ngIf="isRechtspersoon && !isEnkelvoudig">

        <div class="col col-1">
          <p style="padding: 6px">Groepsvermogen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(9)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
  </ng-container>
</ng-container>
<ng-container *ngIf="this.selectedTab === 1">
  <form [formGroup]="equityDisclosureFg">
    <div class="row">
      <div class="col col-1 pt-3" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over eigen vermogen</p>
      </div>
      <div class="col-2 pt-3">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.equityDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(20)">
          {{ this.equityDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            label="In publicatiestukken"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>
  <form [formGroup]="shareCapitalPaidCalledUpDisclosureFg">
    <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over gestort en opgevraagd {{ isCooperatie ? "ledenkapitaal" : "aandelenkapitaal"}}</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.shareCapitalPaidCalledUpDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(10)">
          {{ this.shareCapitalPaidCalledUpDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>
  <form [formGroup]="sharePremiumDisclosureFg">
    <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over agio</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.sharePremiumDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(11)">
          {{ this.sharePremiumDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>
  <form [formGroup]="revaluationReserveDisclosureFg">
    <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over herwaarderingsreserve</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.revaluationReserveDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(12)">
          {{ this.revaluationReserveDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>
  <form [formGroup]="legalReservesDisclosureFg">
    <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over andere wettelijke reserves</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.legalReservesDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(13)">
          {{ this.legalReservesDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>
  <form [formGroup]="statutoryReservesDisclosureFg">
    <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over statutaire reserves</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.statutoryReservesDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(14)">
          {{ this.statutoryReservesDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>
  <form [formGroup]="reservesOtherDisclosureFg">
    <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over overige reserves</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.reservesOtherDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(15)">
          {{ this.reservesOtherDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>
  <form [formGroup]="reinvestmentReserveDisclosureFg">
    <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && isFiscaleGrondslagen">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over herinvesteringsreserve</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.reinvestmentReserveDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(16)">
          {{ this.reinvestmentReserveDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>
  <form [formGroup]="otherFiscalReservesDisclosureFg">
    <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && isFiscaleGrondslagen">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over overige fiscale reserves</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.otherFiscalReservesDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(17)">
          {{ this.otherFiscalReservesDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>
  <form [formGroup]="resultForTheYearDisclosureFg">
    <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && !isBalansNaResultaatbestemming">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over resultaat na belastingen van het boekjaar</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.resultForTheYearDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(18)">
          {{ this.resultForTheYearDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>
  <form [formGroup]="retainedEarningsDisclosureFg">
    <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over niet verdeelde winsten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.retainedEarningsDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(19)">
          {{ this.retainedEarningsDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>
  <form [formGroup]="equityContinuityDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over de continuïteit met effect op het eigen vermogen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.equityContinuityDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(21)">
          {{ this.equityContinuityDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>
  <form [formGroup]="equityWithheldPartResultDescriptionFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van het ingehouden deel van de jaarwinst binnen het eigen vermogen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.equityWithheldPartResultDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(22)">
          {{ this.equityWithheldPartResultDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>

  <form [formGroup]="noncontrollingInterestDisclosureFg">
    <div class="row" *ngIf="isRechtspersoon && !isEnkelvoudig">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over aandeel van derden in groepsmaatschappijen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.noncontrollingInterestDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(23)">
          {{ this.noncontrollingInterestDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>
  <form [formGroup]="equityGroupDisclosureFg">
    <div class="row" *ngIf="isRechtspersoon && !isEnkelvoudig">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over groepsvermogen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.equityGroupDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(24)">
          {{ this.equityGroupDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>
</ng-container>
<ng-container *ngIf="this.selectedTab === 2 && isRechtspersoon && isEnkelvoudig && heeftAandelen">
  <div class="row">
    <div class="col-1-1">
      <p style="padding: 6px"><b>Andere wettelijke reserves</b></p>
    </div>
    <div class="col-2"></div>
    <div class="col-3 bold">
      Huidige periode
    </div>
    <div class="col-4 bold">
      Vorige periode
    </div>
  </div>
  <ng-container *ngIf="this.showCustomControls">
    <form [formGroup]="legalReserveNegativeTranslationShareCapitalIntoEurosFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">

        <div class="col-1-1">
          <p style="padding: 6px">Negatieve bijschrijvingsreserve als gevolg van de omrekening van het aandelenkapitaal
            van een naamloze vennootschap naar de euro</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(100)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="legalReserveTranslationShareCapitalIntoEurosFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">

        <div class="col-1-1">
          <p style="padding: 6px">Niet-uitkeerbare reserve als gevolg van de omrekening van het aandelenkapitaal van een
            naamloze vennootschap naar de euro</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(101)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="legalReserveContributionInKindFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">

        <div class="col-1-1">
          <p style="padding: 6px">Reserve voor inbreng op {{ isCooperatie ? "lidmaatschapsrechten" : "aandelen"}} anders dan in geld</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(102)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="legalReserveLoansProvidedObtainTreasurySharesFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">

        <div class="col-1-1">
          <p style="padding: 6px">Niet-uitkeerbare reserve voor verstrekte lening ter verkrijging door anderen van {{ isCooperatie ? "lidmaatschapsrechten van de entiteit" : "aandelen in het kapitaal van de vennootschap"}} of van certificaten daarvan</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(103)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="legalReserveCostsIncorporationShareIssueFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">

        <div class="col-1-1">
          <p style="padding: 6px">Wettelijke reserve voor kosten die verband houden met de oprichting en met de uitgifte van {{ isCooperatie ? "lidmaatschapsrechten" : "aandelen"}}</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(104)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="legalReserveDevelopmentFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">

        <div class="col-1-1">
          <p style="padding: 6px">Wettelijke reserve voor geactiveerde kosten van ontwikkeling</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(105)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="legalReserveParticipatingInterestsFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">

        <div class="col-1-1">
          <p style="padding: 6px">Wettelijke reserve deelnemingen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(106)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="reserveTranslationDifferencesConversionInvestedAssetsResultParticipatingInterestsFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">

        <div class="col-1-1">
          <p style="padding: 6px">Wettelijke reserve omrekeningsverschillen voor omrekening van het geïnvesteerde
            vermogen en het resultaat van deelnemingen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(107)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="foreignCurrencyTranslationReserveFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">

        <div class="col-1-1">
          <p style="padding: 6px">Reserve omrekeningsverschillen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(108)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="legalReservesFg">
      <div class="row" *ngIf="isRechtspersoon && isEnkelvoudig && heeftAandelen">

        <div class="col-1-1">
          <p style="padding: 6px"><b>Totaal van andere wettelijke reserves</b></p>
        </div>
        <div class="col-2"></div>
        <ng-container>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </ng-container>
      </div>
    </form>
  </ng-container>
</ng-container>

<div *ngIf="this.index === 0">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.shareCapitalPaidCalledUpFg"
                                                       [title]="`gestort en opgevraagd ${isCooperatie ? 'ledenkapitaal' : 'aandelenkapitaal'}`"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 1">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.sharePremiumFg"
                                                       [title]="'agio'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 2">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.revaluationReserveFg"
                                                       [title]="'herwaarderingsreserve'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 3">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.statutoryReservesFg"
                                                       [title]="'statutaire reserves'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 4">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.reservesOtherFg"
                                                       [title]="'overige reserves'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 42">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.reinvestmentReserveFg"
                                                       [title]="'herinvesteringsreserve'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 41">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.otherFiscalReservesFg"
                                                       [title]="'overige fiscale reserves'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 6">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.retainedEarningsFg"
                                                       [title]="'niet verdeelde winsten'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 8">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.noncontrollingInterestFg"
                                                       [title]="'aandeel van derden in groepsmaatschappijen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 9">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.equityGroupFg"
                                                       [title]="'groepsvermogen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>

<div *ngIf="this.index === 10">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.shareCapitalPaidCalledUpDisclosureFg"
                                                               [title]="`Informatieverschaffing over gestort en opgevraagd ${isCooperatie ? 'ledenkapitaal' : 'aandelenkapitaal'}`"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 11">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.sharePremiumDisclosureFg"
                                                               [title]="'Informatieverschaffing over agio'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 12">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.revaluationReserveDisclosureFg"
                                                               [title]="'Informatieverschaffing over herwaarderingsreserve'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 13">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.legalReservesDisclosureFg"
                                                               [title]="'Informatieverschaffing over andere wettelijke reserves'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 14">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.statutoryReservesDisclosureFg"
                                                               [title]="'Informatieverschaffing over statutaire reserves'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 15">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.reservesOtherDisclosureFg"
                                                               [title]="'Informatieverschaffing over overige reserves'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 16">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.reinvestmentReserveDisclosureFg"
                                                               [title]="'Informatieverschaffing over herinvesteringsreserve'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 17">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.otherFiscalReservesDisclosureFg"
                                                               [title]="'Informatieverschaffing over overige fiscale reserves'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 18">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.resultForTheYearDisclosureFg"
                                                               [title]="'Informatieverschaffing over resultaat na belastingen van het boekjaar'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 19">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.retainedEarningsDisclosureFg"
                                                               [title]="'Informatieverschaffing over niet verdeelde winsten'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 20">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.equityDisclosureFg"
                                                               [title]="'Informatieverschaffing over eigen vermogen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 21">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.equityContinuityDisclosureFg"
                                                               [title]="'Informatieverschaffing over continuïteit met effect op het eigen vermogen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 22">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.equityWithheldPartResultDescriptionFg"
                                                               [title]="'Beschrijving van het ingehouden deel van de jaarwinst binnen het eigen vermogen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>

<div *ngIf="this.index === 23">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.noncontrollingInterestDisclosureFg"
                                                               [title]="'Informatieverschaffing over aandeel van derden in groepsmaatschappijen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 24">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.equityGroupDisclosureFg"
                                                               [title]="'Informatieverschaffing over groepsvermogen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>

<div *ngIf="this.index === 100">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.legalReserveNegativeTranslationShareCapitalIntoEurosFg"
                                                       [title]="'negatieve bijschrijvingsreserve als gevolg van de omrekening van het aandelenkapitaal van een naamloze vennootschap naar de euro'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 101">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.legalReserveTranslationShareCapitalIntoEurosFg"
                                                       [title]="'niet-uitkeerbare reserve als gevolg van de omrekening van het aandelenkapitaal van een naamloze vennootschap naar de euro'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 102">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.legalReserveContributionInKindFg"
                                                       [title]="`reserve voor inbreng op ${isCooperatie ? 'lidmaatschapsrechten' : 'aandelen'} anders dan in geld`"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 103">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.legalReserveLoansProvidedObtainTreasurySharesFg"
                                                       [title]="`niet-uitkeerbare reserve voor verstrekte lening ter verkrijging door anderen van ${isCooperatie ? 'lidmaatschapsrechten van de entiteit' : 'aandelen in het kapitaal van de vennootschap'} of van certificaten daarvan`"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 104">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.legalReserveCostsIncorporationShareIssueFg"
                                                       [title]="`wettelijke reserve voor kosten die verband houden met de oprichting en met de uitgifte van ${isCooperatie ? 'lidmaatschapsrechten' : 'aandelen'}`"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 105">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.legalReserveDevelopmentFg"
                                                       [title]="'wettelijke reserve voor geactiveerde kosten van ontwikkeling'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 106">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.legalReserveParticipatingInterestsFg"
                                                       [title]="'wettelijke reserve deelnemingen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 107">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.reserveTranslationDifferencesConversionInvestedAssetsResultParticipatingInterestsFg"
                                                       [title]="'wettelijke reserve omrekeningsverschillen voor omrekening van het geïnvesteerde vermogen en het resultaat van deelnemingen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 108">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.foreignCurrencyTranslationReserveFg"
                                                       [title]="'reserve omrekeningsverschillen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>

<snelstart-ui-dialog-definition id="balansChangeDialog"
                                title="Waarde wijzigen - Balans voor of na resultaatbestemming"
                                size="lg"
                                [(visible)]="openInfoVBalansNaResultaatbestemming">
  <snelstart-ui-dialog-body>
    <div class="ps-1">
      <p>
        Weet je zeker dat je de waarde wilt wijzigen naar
        '<strong>{{ pendingValue === 'NA' ? 'Na resultaatbestemming' : 'Voor resultaatbestemming' }}'</strong>?
      </p>
    </div>

    <div class="ps-1">
      <p class="mb-2">
        <strong>Let op:</strong> het wijzigen van deze waarde heeft grote invloed op de wijze waarop het resultaat wordt
        verwerkt binnen het eigen vermogen.
      </p>
      <ul>
        <li>
          Bij wijzigen naar '<strong>Voor resultaatbestemming</strong>' vindt de verwerking voortaan automatisch plaats
          en het resultaat uit de winst-en-verliesrekening wordt steeds één-op-één opgenomen in de eigen vermogen post
          'Resultaat na belastingen van het boekjaar'. Je bent zelf verantwoordelijk voor het verwijderen van
          (eventueel) eerder handmatig verwerkt resultaat op andere posten binnen het eigen vermogen.
        </li>
        <br/>
        <li>
          Bij wijzigen naar '<strong>Na resultaatbestemming</strong>' bestaat de post 'Resultaat na belastingen van het
          boekjaar' niet meer en derhalve verdwijnt het automatisch verwerkte resultaat uit het eigen vermogen. Je bent
          steeds zelf verantwoordelijk voor het op de juiste wijze en volledig opnemen van het resultaat binnen het
          eigen vermogen.
        </li>
      </ul>
    </div>
  </snelstart-ui-dialog-body>

  <snelstart-ui-dialog-buttons class="d-flex mt-2">
    <snelstart-ui-button type="secondary" icon="xmark" btn-x
                         (click)="cancelChange()">Nee, annuleren
    </snelstart-ui-button>

    <snelstart-ui-button class="ps-3" type="primary" icon="check"
                         (click)="confirmChange()">Ja, bevestigen
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

